import React from 'react'
import {IoLocationSharp} from 'react-icons/io5'
import {AiOutlineMail} from 'react-icons/ai'
import {IoMdCall} from 'react-icons/io'
import {AiFillInstagram} from 'react-icons/ai'
import {AiFillYoutube} from 'react-icons/ai'
import {AiFillLinkedin} from 'react-icons/ai'
import {SiGooglemybusiness} from 'react-icons/si'
import {AiOutlineCopyrightCircle} from 'react-icons/ai'
import foot from '../../img/intelli X Logo-2.png';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    <div>
      
    <section style={{backgroundColor:'#1e1e1e'}}>
    <div className='container'>
     <div className='row'> 
    <div className='col-lg-2 col-md-6 col-sm-12'> 
    <img src={foot} alt='/' style={{width:'100%'}}/> 
    </div>
    </div>


    <div className='row'>
     <div className='col-lg-3 col-md-6 col-sm-12'>
        <p className='mt-3 ms-2' style={{color:'#a9a9a9'}}>Locate Us</p>


        
        <NavLink to='https://goo.gl/maps/aUWWgJ4HWDN3cFLW7' style={{textDecoration:'none'}}>
        <div className='text-white d-flex mt-3  '>
        <IoLocationSharp className='me-2' style={{fontSize:'29px'}}/> <p>101-103, Chanda Tower Vaishali nagar, Jaipur - 302021</p>
         
        </div>
        </NavLink>


        <NavLink to='mailto: abc@example.com' style={{textDecoration:'none'}}>
        <div className='text-white d-flex mt-2'>
        <AiOutlineMail className='me-2' style={{fontSize:'20px'}}/> <p>info@intellix360.com</p> 
        </div>
        </NavLink>



        <NavLink to='tel:9116514171' style={{textDecoration:'none'}}>
         <div className='text-white d-flex align-item-center mt-2'>
        <IoMdCall className='me-2 mt-1' style={{fontSize:'20px'}}/> <p>1800-333-444</p>
         
        </div>

        </NavLink>

     </div>


     <div className='col-lg-3 col-md-6 col-sm-12'>
        <div className='mt-0'>
         <p style={{color:'#A9A9A9',cursor:"pointer"}}>About Us</p>
        </div>     
      
        <NavLink to='/Pricing' style={{textDecoration:'none'}}>
        <div className='mt-3'>
         <p style={{color:'#A9A9A9'}}>Pricings</p>
        </div>   
        </NavLink>  
      
        <NavLink to="" style={{textDecoration:'none'}}>
        <div className='mt-3'>
         <p style={{color:'#A9A9A9'}}>Grievance Redressal</p>
        </div>    
        </NavLink> 
      

        <NavLink to='/Talk' style={{textDecoration:'none'}}>
        <div className='mt-3'>
         <p style={{color:'#A9A9A9'}}>Talk to Us</p>
        </div>  
        </NavLink>   
      
        <NavLink to="" style={{textDecoration:'none'}}>
        <div className='mt-3'>
         <p style={{color:'#A9A9A9'}}>B2B Collaboration</p>
        </div>
        </NavLink>     
      
        <NavLink to="" style={{textDecoration:'none'}}>
        <div className='mt-3'>
         <p style={{color:'#A9A9A9'}}>Partners</p>
        </div> 
        </NavLink>    
 

     </div>

     <div className='col-lg-3 col-md-6 col-sm-12'>
        <div className='mt-0'>
         <p style={{color:'#A9A9A9',cursor:"pointer"}}>Products</p>
        </div>     
      
        <NavLink to='/Product'  style={{textDecoration:'none'}}>
        <div className='mt-3'>
         <p style={{color:'#fff',cursor:"pointer"}}>Genius StriX</p>
        </div>     
         </NavLink>

        <NavLink to='/CogniCampuX'  style={{textDecoration:'none'}}>
        <div className='mt-3'>
         <p style={{color:'#fff'}}>Cogni CampX</p>
        </div>     
        </NavLink>
      

        <NavLink to='/Hms'  style={{textDecoration:'none'}}>
        <div className='mt-3'>
         <p style={{color:'#fff'}}>HMS Hostello</p>
        </div>     
        </NavLink>
      

        <NavLink to='/PrivacyPolicy'  style={{textDecoration:'none'}}>
        <div className='mt-3'>
         <p style={{color:'#A9A9A9'}}>Privacy Policy</p>
        </div>   
        </NavLink>  
      
        <NavLink to='/Refundpolicy' style={{textDecoration:'none'}}>
        <div className='mt-3'>
         <p style={{color:'#A9A9A9'}}>Refund Policy</p>
        </div>   
        </NavLink>  
 

     </div>




     
     <div className='col-lg-3 col-md-6 col-sm-12'>
     <NavLink to='/Help'  style={{textDecoration:'none'}}>
        <div className='mt-0'>
         <p style={{color:'#A9A9A9'}}>Support</p>
        </div>     
        </NavLink>
      
        <NavLink to='/Help'  style={{textDecoration:'none'}}> 
        <div className='mt-3'>
         <p style={{color:'#A9A9A9'}}>Help & Feedback</p>
        </div>     
        </NavLink>
      
        <NavLink to="" style={{textDecoration:'none'}}>
        <div className='mt-3'>
         <p style={{color:'#A9A9A9 '}}>How To Use</p>
        </div>   
        </NavLink>  
      

        <NavLink to="/Help" style={{textDecoration:'none'}}>
        <div className='mt-3'>
         <p style={{color:'#A9A9A9'}}>FAQs</p>
        </div>     
            </NavLink>
 

     </div>
    </div>


    </div>

    <div className='container-fluid'> 
    <div className='row' style={{backgroundColor:'#3572FA'}}>
      
    <div className='col-lg-4 col-md-6 col-sm-12 pt-3'>
     <p className='text-white text-center' > <AiOutlineCopyrightCircle style={{fontSize:'18px'}}/> We RNS IT Solutions Private Limited </p>   
    </div>
      
    <div className='col-lg-1 col-md-6 col-sm-12 pt-3'>  
    </div>


    <div className='col-lg-2 col-md-6 col-sm-12 pt-3'>
    <NavLink to='UserLicense' style={{textDecoration:'none'}}> 
    <p className='text-white text-center'>User License Agreement</p>  
    </NavLink>
    </div>


    <div className='col-lg-2 col-md-6 col-sm-12 pt-3'>
    <NavLink to='DataPrivacy' style={{textDecoration:'none'}}>
    <p className='text-white text-center'>Terms & Conditions</p>  
    </NavLink>
    </div>

    <div className='col-lg-2 col-md-6 col-sm-12 pt-3'>
      
    <div  style={{display:'flex', justifyContent:'space-around'}}>
     <AiFillInstagram style={{color:'#fff', fontSize:'25px'}}/>
     <AiFillYoutube style={{color:'#fff', fontSize:'25px'}} />
     <AiFillLinkedin style={{color:'#fff', fontSize:'25px'}} />  
     <SiGooglemybusiness style={{color:'#fff', fontSize:'25px'}} />  
    </div>
     

    </div>




    </div>
    </div>
   </section>
    </div>
  )
}

export default Footer
